import { Link } from "@inertiajs/react"
import { Fragment } from "react"

export const BreadCrumbs = ({ breadcrumbs = [] }) => {
    if (!breadcrumbs.length) {
        return null
    }

    return (
        <nav aria-label="breadcrumb" style={{ marginBottom: "20px" }}>
            <div className="hidden lg:block text-xl font-light leading-[15px]">
                {breadcrumbs.map((crumb, index) => {
                    const isLast = index === breadcrumbs.length - 1

                    return (
                        <Fragment key={index}>
                            {index > 0 && (
                                <span className="mx-3" style={{ opacity: 0.5 }}>
                                    {" / "}
                                </span>
                            )}
                            {isLast ? (
                                <span style={{ fontWeight: 700, color: "#637648" }}>
                                    {crumb.text}
                                </span>
                            ) : (
                                <Link
                                    href={crumb.href}
                                    style={{ fontWeight: 500, color: "#637648" }}
                                >
                                    {crumb.text}
                                </Link>
                            )}
                        </Fragment>
                    )
                })}
            </div>
        </nav>
    )
}
